if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart = this.getCart();
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";

        this.initBOGOButton();
      }

      getCart() {
        const cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");

        if (
          !cart ||
          typeof cart.getSectionsToRender !== "function" ||
          typeof cart.renderContents !== "function"
        )
          return null;

        return cart;
      }

      initBOGOButton() {
        const bogoButton = this.querySelector("[data-bogo-button]");
        if (!bogoButton) return;

        bogoButton.addEventListener("click", this.onBOGOHandler.bind(this));
      }

      onBOGOHandler(evt) {
        evt.preventDefault();
        const bogoButton = evt.currentTarget;
        const variantId = bogoButton.dataset.variantId;

        if (!variantId) return;

        if (bogoButton.getAttribute("aria-disabled") === "true") return;

        this.cart = this.getCart();
        this.handleErrorMessage();

        bogoButton.setAttribute("aria-disabled", true);
        bogoButton.classList.add("loading");
        bogoButton
          .querySelector(".loading-overlay__spinner")
          .classList.remove("hidden");

        const sections = this.cart
          ? this.cart.getSectionsToRender().map((section) => section.id)
          : null;
        const sectionsUrl = window.location.pathname;
        if (this.cart) this.cart.setActiveElement(document.activeElement);

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";

        const items = [{ id: Number(variantId), quantity: 2 }];

        if (sections) {
          config.body = JSON.stringify({
            items,
            sections,
            sections_url: sectionsUrl,
          });
        } else {
          config.body = JSON.stringify({ items });
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: variantId,
                errors: response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: variantId,
              });
            this.error = false;

            if (this.cart) {
              this.cart.skipWarranty = true;
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            bogoButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) bogoButton.removeAttribute("aria-disabled");
            bogoButton
              .querySelector(".loading-overlay__spinner")
              .classList.add("hidden");
          });
      }

      getAddOnLineItems() {
        const scope =
          this.closest("[data-section]") || this.closest("section") || document;
        const addOnItems = scope.querySelectorAll(
          "[data-addon-item][data-addon-variant-id]",
        );

        return Array.from(addOnItems)
          .map((item) => {
            const variantId = Number(
              item.getAttribute("data-addon-variant-id"),
            );
            const input = item.querySelector("[data-addon-quantity-input]");
            const quantity = Number(input?.value || 0);
            if (
              !Number.isFinite(variantId) ||
              !Number.isFinite(quantity) ||
              quantity <= 0
            )
              return null;
            return { id: variantId, quantity };
          })
          .filter(Boolean);
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.cart = this.getCart();
        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        const spinner = this.submitButton.querySelector(
          ".loading-overlay__spinner",
        );
        if (spinner) spinner.classList.remove("hidden");

        const formData = new FormData(this.form);
        const addOnLineItems = this.getAddOnLineItems();
        const useMultiAdd = addOnLineItems.length > 0;

        const mainVariantId = Number(formData.get("id"));
        const mainQuantity = Number(formData.get("quantity") || 1);
        const addedItemQuantity =
          Number.isFinite(mainQuantity) && mainQuantity > 0 ? mainQuantity : 1;

        const sections = this.cart
          ? this.cart.getSectionsToRender().map((section) => section.id)
          : null;
        const sectionsUrl = window.location.pathname;
        if (this.cart) this.cart.setActiveElement(document.activeElement);

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";

        if (useMultiAdd) {
          const items = [
            { id: mainVariantId, quantity: mainQuantity },
            ...addOnLineItems,
          ];
          if (sections) {
            config.body = JSON.stringify({
              items,
              sections,
              sections_url: sectionsUrl,
            });
          } else {
            config.body = JSON.stringify({ items });
          }
        } else {
          delete config.headers["Content-Type"];
          if (sections) {
            formData.append("sections", sections);
            formData.append("sections_url", sectionsUrl);
          }
          config.body = formData;
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
              });
            this.error = false;
            const renderResponse = {
              ...response,
              addedItemQuantity,
            };
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(renderResponse);
                  });
                },
                { once: true },
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(renderResponse);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            if (spinner) spinner.classList.add("hidden");
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message",
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    },
  );
}

if (!customElements.get("open-box-solar-pack")) {
  customElements.define(
    "open-box-solar-pack",
    class OpenBoxSolarPack extends HTMLElement {
      constructor() {
        super();

        this.button = this.querySelector("[data-open-box-solar-add]");
        this.faceplateSelect = this.querySelector("[data-open-box-solar-faceplate]");
        this.totalElement = this.querySelector("[data-open-box-solar-total]");
        this.errorElement = this.querySelector("[data-open-box-solar-error]");
        this.statusElement = this.querySelector("[data-open-box-solar-status]");
        this.modal = this.querySelector("[data-open-box-solar-modal]");
        this.modalDialog = this.querySelector("[data-open-box-solar-dialog]");
        this.confirmButton = this.querySelector("[data-open-box-solar-confirm]");
        this.cancelButtons = this.querySelectorAll("[data-open-box-solar-cancel]");
        this.discountCode = this.dataset.openBoxSolarDiscountCode || "";
        this.cart = this.getCart();
        this.pendingItems = null;
        this.previousActiveElement = null;

        if (this.faceplateSelect) {
          this.faceplateSelect.addEventListener("change", () => this.updateTotal());
          this.updateTotal();
        }

        if (this.button) {
          if (document.querySelector("cart-drawer")) {
            this.button.setAttribute("aria-haspopup", "dialog");
          }
          this.button.addEventListener("click", this.onAddClick.bind(this));
        }

        if (this.confirmButton) {
          this.confirmButton.addEventListener("click", this.onConfirmClick.bind(this));
        }

        this.cancelButtons.forEach((button) => {
          button.addEventListener("click", () => this.closeConfirmationModal());
        });

        this.addEventListener("keydown", (event) => {
          if (event.key === "Escape" && this.modal && !this.modal.hidden) {
            this.closeConfirmationModal();
          }
        });
      }

      getCart() {
        const cart =
          document.querySelector("cart-drawer") ||
          document.querySelector("cart-notification");

        if (
          !cart ||
          typeof cart.getSectionsToRender !== "function" ||
          typeof cart.renderContents !== "function"
        )
          return null;

        return cart;
      }

      getSelectedFaceplateVariantId() {
        return Number(this.faceplateSelect?.value);
      }

      getSelectedFaceplatePrice() {
        const selectedOption = this.faceplateSelect?.selectedOptions?.[0];
        return Number(selectedOption?.dataset.price || 0);
      }

      updateTotal() {
        if (!this.totalElement) return;

        this.totalElement.textContent = this.formatMoney(
          this.getSelectedFaceplatePrice(),
        );
      }

      formatMoney(cents) {
        if (
          typeof Shopify !== "undefined" &&
          typeof Shopify.formatMoney === "function"
        ) {
          return Shopify.formatMoney(cents, "${{amount}}");
        }

        return new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
        }).format((Number(cents) || 0) / 100);
      }

      setLoading(isLoading) {
        [this.button, this.confirmButton].filter(Boolean).forEach((button) => {
          button.classList.toggle("loading", isLoading);
          button.disabled = isLoading;
          button.setAttribute("aria-disabled", isLoading ? "true" : "false");
          button
            .querySelector(".loading-overlay__spinner")
            ?.classList.toggle("hidden", !isLoading);
        });
      }

      setError(message) {
        if (!this.errorElement) return;

        if (message) {
          this.errorElement.textContent = message;
          this.errorElement.hidden = false;
        } else {
          this.errorElement.hidden = true;
        }
      }

      setStatus(message) {
        if (this.statusElement) this.statusElement.textContent = message || "";
      }

      getBundleProperties() {
        return {
          _bundle: "open-box-solar-pack",
          _bundle_title: "Open Box Solar Pack",
          _upsell_skip: "true",
        };
      }

      getLineItems() {
        const variantId = this.getSelectedFaceplateVariantId();

        if (!Number.isFinite(variantId)) return [];

        return [
          {
            id: variantId,
            quantity: 1,
            properties: this.getBundleProperties(),
          },
        ];
      }

      onAddClick(event) {
        event.preventDefault();
        if (!this.button || this.button.getAttribute("aria-disabled") === "true") return;

        const items = this.getLineItems();
        if (items.length !== 1) {
          this.setError("This open-box solar pack is not fully configured.");
          return;
        }

        this.pendingItems = items;
        this.openConfirmationModal();
      }

      onConfirmClick(event) {
        event.preventDefault();
        if (!this.pendingItems || this.pendingItems.length !== 1) return;

        const items = this.pendingItems;
        this.pendingItems = null;
        this.closeConfirmationModal(false, false);
        this.addBundle(items);
      }

      openConfirmationModal() {
        if (!this.modal) {
          this.addBundle(this.pendingItems);
          return;
        }

        this.previousActiveElement = document.activeElement;
        this.modal.hidden = false;
        document.body.classList.add("open-box-solar-pack-modal-open");
        setTimeout(() => {
          if (typeof trapFocus === "function") {
            trapFocus(this.modalDialog, this.modalDialog);
          } else {
            this.modalDialog?.focus();
          }
        }, 0);
      }

      closeConfirmationModal(restoreFocus = true, clearPending = true) {
        if (!this.modal) return;

        this.modal.hidden = true;
        document.body.classList.remove("open-box-solar-pack-modal-open");
        if (typeof removeTrapFocus === "function") removeTrapFocus();
        if (clearPending) this.pendingItems = null;

        if (
          restoreFocus &&
          this.previousActiveElement &&
          typeof this.previousActiveElement.focus === "function"
        ) {
          this.previousActiveElement.focus();
        }
      }

      addBundle(items) {
        this.cart = this.getCart();
        this.setLoading(true);
        this.setError("");
        this.setStatus("Adding Open Box Solar Pack to your cart...");

        const sections = this.cart
          ? this.cart.getSectionsToRender().map((section) => section.id)
          : null;
        const sectionsUrl = window.location.pathname;
        if (this.cart) this.cart.setActiveElement(document.activeElement);

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";

        if (sections) {
          config.body = JSON.stringify({
            items,
            sections,
            sections_url: sectionsUrl,
          });
        } else {
          config.body = JSON.stringify({ items });
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.setError(response.description || response.message);
              this.setStatus("");
              return;
            }

            if (!this.cart) {
              if (this.discountCode) {
                window.location = `/discount/${encodeURIComponent(
                  this.discountCode,
                )}?redirect=${encodeURIComponent(window.routes.cart_url)}`;
              } else {
                window.location = window.routes.cart_url;
              }
              return;
            }

            return this.applyDiscountCode(sections, sectionsUrl)
              .catch((error) => {
                console.error(error);
                return { discountError: true };
              })
              .then((discountResult) => {
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: "open-box-solar-pack",
                  productVariantId: items[0].id,
                });

                const discountResponse = discountResult?.discountError
                  ? null
                  : discountResult;
                const renderResponse =
                  this.cart.tagName.toLowerCase() === "cart-notification"
                    ? response
                    : discountResponse || response;
                const discountErrorMessage =
                  "The Open Box Solar Pack was added, but free shipping could not be applied automatically. Please contact us before checkout.";

                this.cart.skipWarranty = true;
                this.cart.renderContents(renderResponse);
                if (discountResult?.discountError) {
                  this.setError(discountErrorMessage);
                  this.showCartError(discountErrorMessage);
                }
                this.setStatus("Open Box Solar Pack added to your cart.");
              });
          })
          .catch((error) => {
            console.error(error);
            this.setError(
              "There was an error adding the Open Box Solar Pack or applying free shipping.",
            );
            this.setStatus("");
          })
          .finally(() => {
            this.setLoading(false);
            if (this.cart && this.cart.classList.contains("is-empty")) {
              this.cart.classList.remove("is-empty");
            }
          });
      }

      applyDiscountCode(sections, sectionsUrl) {
        if (!this.discountCode) return Promise.resolve(null);

        return this.getCartState()
          .then((cart) => {
            const existingCodes = (cart?.discount_codes || [])
              .map((discount) => discount.code)
              .filter(Boolean);
            const discountCodes = Array.from(
              new Set([...existingCodes, this.discountCode]),
            );
            const config = fetchConfig("javascript");
            config.headers["X-Requested-With"] = "XMLHttpRequest";
            config.body = JSON.stringify({
              discount: discountCodes.join(","),
              sections,
              sections_url: sectionsUrl,
            });

            return fetch(`${routes.cart_update_url}`, config);
          })
          .then((response) => response.json())
          .then((response) => {
            const discount = response.discount_codes?.find(
              (discountCode) => discountCode.code === this.discountCode,
            );

            if (!discount || discount.applicable === false) {
              throw new Error("Open Box Solar Pack free-shipping code is not applicable.");
            }

            return response;
          });
      }

      getCartState() {
        return fetch("/cart.js", {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            Accept: "application/json",
          },
        }).then((response) => response.json());
      }

      showCartError(message) {
        const errorElement =
          document.getElementById("CartDrawer-CartErrors") ||
          document.getElementById("cart-errors");

        if (errorElement) errorElement.textContent = message;
      }
    },
  );
}

class stickyCartModal extends HTMLElement {
  constructor() {
    super();
    window.addEventListener("scroll", this.update.bind(this));
    this.update();
    const footer = document.querySelector("footer");
    if (footer) footer.classList.add("sticky-cart-modal_bottom_padding");

    this.initMarquee();
  }

  initMarquee() {
    this.scrollContainer = this.querySelector(
      ".sticky-cart__meta-title-scroll",
    );
    if (!this.scrollContainer) return;

    this.isDragging = false;
    this.startX = 0;
    this.currentTranslate = 0;
    this.prevTranslate = 0;
    this.animationId = null;
    this.cachedHalfWidth = 0;
    this.rafId = null;

    // Bind touch events with passive: true for better scrolling performance
    this.scrollContainer.addEventListener(
      "touchstart",
      this.handleTouchStart.bind(this),
      { passive: true },
    );
    this.scrollContainer.addEventListener(
      "touchmove",
      this.handleTouchMove.bind(this),
      { passive: true },
    );
    this.scrollContainer.addEventListener(
      "touchend",
      this.handleTouchEnd.bind(this),
    );
  }

  handleTouchStart(e) {
    this.isDragging = true;
    this.startX = e.touches[0].clientX;

    // Cache the width at start of drag to avoid layout thrashing and potential zero-width issues during drag
    const totalWidth = this.scrollContainer.scrollWidth;
    this.cachedHalfWidth = totalWidth / 2;

    // Stop CSS animation and take over if not already done
    if (this.scrollContainer.style.animation !== "none") {
      const computedStyle = window.getComputedStyle(this.scrollContainer);
      const matrix = new DOMMatrix(computedStyle.transform);
      this.currentTranslate = matrix.m41 || 0; // m41 is translateX

      this.scrollContainer.style.animation = "none";
      this.scrollContainer.style.transform = `translateX(${this.currentTranslate}px)`;
    }

    // Cancel any running JS animation loop so we can drag manually
    if (this.animationId) {
      cancelAnimationFrame(this.animationId);
      this.animationId = null;
    }

    if (this.rafId) {
      cancelAnimationFrame(this.rafId);
      this.rafId = null;
    }

    this.prevTranslate = this.currentTranslate;
  }

  handleTouchMove(e) {
    if (!this.isDragging) return;

    // Throttle updates using requestAnimationFrame
    if (this.rafId) return;

    const x = e.touches[0].clientX;

    this.rafId = requestAnimationFrame(() => {
      const walk = x - this.startX;
      this.currentTranslate = this.prevTranslate + walk;
      this.setTransform();
      this.rafId = null;
    });
  }

  handleTouchEnd() {
    this.isDragging = false;
    if (this.rafId) {
      cancelAnimationFrame(this.rafId);
      this.rafId = null;
    }
    this.startAnimationLoop();
  }

  startAnimationLoop() {
    let lastTime = null;

    // Refresh cached width in case it changed (unlikely during drag but possible if orientation changed)
    this.cachedHalfWidth = this.scrollContainer.scrollWidth / 2;

    const loop = (time) => {
      if (this.isDragging) return;
      if (lastTime === null) lastTime = time;

      const dt = time - lastTime;
      lastTime = time;

      // Calculate speed: width / 2 in 15000ms (matches CSS 15s)
      const speed =
        this.cachedHalfWidth > 0 ? this.cachedHalfWidth / 15000 : 0.05;

      // Move left
      this.currentTranslate -= speed * dt;
      this.setTransform();

      this.animationId = requestAnimationFrame(loop);
    };
    this.animationId = requestAnimationFrame(loop);
  }

  setTransform() {
    // Robust wrapping logic
    // Use cached width if available to avoid layout reads
    let halfWidth = this.cachedHalfWidth;
    if (!halfWidth || halfWidth <= 0) {
      halfWidth = this.scrollContainer.scrollWidth / 2;
      this.cachedHalfWidth = halfWidth;
    }

    // Protection against NaN
    if (isNaN(this.currentTranslate)) {
      this.currentTranslate = 0;
    }

    if (halfWidth > 0) {
      // Wrap: ensure we are in range [-halfWidth, 0]
      // Use remainder operator
      this.currentTranslate = this.currentTranslate % halfWidth;

      // If positive, shift back to negative range
      if (this.currentTranslate > 0) {
        this.currentTranslate -= halfWidth;
      }

      // Extra safety: if somehow we are still positive (e.g. -0 vs +0), force it
      if (this.currentTranslate > 0) this.currentTranslate = 0;
    }

    this.scrollContainer.style.transform = `translate3d(${this.currentTranslate}px, 0, 0)`;
  }

  update() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`,
    );
    if (!button) return;

    const addButton = button.querySelector('[name="add"]');
    if (!addButton) return;

    const rangeToShowModal = this.getTop(addButton) + button.clientHeight;
    if (
      window.scrollY >= rangeToShowModal &&
      !this.classList.contains("show-modal")
    ) {
      this.classList.add("show-modal");
      document.querySelector("body").classList.add("modal__sticky-cart");
    }
    if (
      window.scrollY < rangeToShowModal &&
      this.classList.contains("show-modal")
    ) {
      this.classList.remove("show-modal");
      document.querySelector("body").classList.remove("modal__sticky-cart");
    }
  }
  getTop(el) {
    return el.offsetTop + (el.offsetParent && this.getTop(el.offsetParent));
  }
}
customElements.define("sticky-cart-modal", stickyCartModal);
